module.exports = __webpack_public_path__ + "static/img/Promocard-2.2d8bf53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promoTest/Promocard-2.png
// module id = ypwi
// module chunks = 11